import { Box } from '@mui/material';
import { Button } from '../../../Button';


export type AddInsuranceActionsBarType = {
  cancel?: () => void;
  back?: () => void;
  next?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  loading?: boolean;
};

export const AddInsuranceActionsBar: React.VFC<AddInsuranceActionsBarType> = ({
  cancel,
  back,
  next,
  nextLabel,
  nextDisabled = false,
  loading = false
}) => {
  return (
    <Box display="flex" alignItems="center">
      <Box flex={1}>
        {cancel && <Button onClick={cancel}>Cancel</Button>}
      </Box>
      <Box display="flex" gap="8px">
        {back && <Button onClick={back}>Back</Button>}
        {next && (
          <Button
            variant="contained"
            color="secondary"
            onClick={next}
            loading={loading}
            disabled={nextDisabled}
          >
            {nextLabel ?? 'Next'}
          </Button>
        )}
      </Box>
    </Box>
  );
};
